import { useMemo } from 'react';
import { Box, Drawer, Typography } from '@mui/material';

import { NavGroup, NavLink } from './components';
import { appRoutes } from '@/utils/supportAdminNavigation';

import styles from './sidebar.module.css';
import { colors } from '@/theme/colors';
import { useSystemContext } from '@/providers/SystemProvider';

export default function Sidebar({ isOpen, setIsOpen, isLoggedIn }) {
  const { config } = useSystemContext();
  const {
    supportTools,
    adminPortal,
    siteAdministration,
    footer,
    system,
    documentation,
    salesAdministration,
  } = useMemo(() => appRoutes(), []);

  return (
    <>
      <Drawer
        open={isOpen}
        onClose={() => setIsOpen(false)}
        sx={{
          '& .MuiPaper-root': {
            width: '250px',
            padding: '0',
            backgroundColor: colors.surfaces.layerThree,
            borderRadius: '0',
          },
        }}
      >
        <Box sx={{ display: 'flex', justifyContent: 'center', padding: '16px' }}>
          <Typography variant="h3" color={colors.text.heading}>
            {config?.brand?.brandName} HQ
          </Typography>
        </Box>
        {isLoggedIn ? (
          <Box
            sx={{
              width: '100%',
              overflowY: 'auto',
              '&::-webkit-scrollbar': {
                width: '4px',
                borderRadius: '8px',
              },
              '&::-webkit-scrollbar-track': {
                borderRadius: '8px',
              },
              '&::-webkit-scrollbar-thumb': {
                backgroundColor: colors.surfaces.layerOne,
                borderRadius: '100px',
                height: '20px',
                width: '3px',
              },
            }}
          >
            <NavLink {...supportTools} setIsDrawerOpen={setIsOpen} />
            <NavGroup {...siteAdministration} setIsDrawerOpen={setIsOpen} />
            <NavLink {...salesAdministration} setIsDrawerOpen={setIsOpen} />
            <NavLink {...adminPortal} setIsDrawerOpen={setIsOpen} />
            <NavLink {...system} setIsDrawerOpen={setIsOpen} />
            <NavLink {...documentation} setIsDrawerOpen={setIsOpen} />
          </Box>
        ) : (
          <Box sx={{ width: '100%', overflowY: 'auto' }}>
            <NavLink {...documentation} setIsDrawerOpen={setIsOpen} />
          </Box>
        )}

        <div className={styles.footerLinks}>
          {isLoggedIn ? (
            <NavLink {...footer.logout} setIsDrawerOpen={setIsOpen} />
          ) : (
            <NavLink {...footer.login} setIsDrawerOpen={setIsOpen} />
          )}
        </div>
      </Drawer>
    </>
  );
}
